import { KeyboardEvent } from 'react';

export function activateOnKeyDown(event: KeyboardEvent<HTMLElement>, activate: () => void) {
	if (event.key === 'Enter' || event.key === ' ') {
		event.preventDefault();
		activate();
	}
}
